import { render, staticRenderFns } from "./MasterAksesMenu.vue?vue&type=template&id=0791257e&"
import script from "./MasterAksesMenu.vue?vue&type=script&lang=js&"
export * from "./MasterAksesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports